import AndyBernard from "../images/AndyBernard.jpg";
import AngelaMartin from "../images/AngelaMartin.jpg";
import CreedBratton from "../images/CreedBratton.jpg";
import DwightSchrute from "../images/DwightSchrute.jpg";
import ErinHannon from "../images/ErinHannon.jpg";
import JimHalpert from "../images/JimHalpert.jpg";
import KevinMalone from "../images/KevinMalone.jpg";
import MichaelScott from "../images/MichaelScott.png";
import PamBeesly from "../images/PamBeesly.jpg";
import StanleyHudson from "../images/StanleyHudson.jpg";
import TobyFlenderson from "../images/TobyFlenderson.jpg";

export default {
    AndyBernard,
    AngelaMartin,
    CreedBratton,
    DwightSchrute,
    ErinHannon,
    JimHalpert,
    KevinMalone,
    MichaelScott,
    PamBeesly,
    StanleyHudson,
    TobyFlenderson
}